import { AsyncPipe } from '@angular/common';
import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform, inject } from '@angular/core';

import { Observable, map } from 'rxjs';

import { WeekdayMap } from '@fcom/core/utils/date';
import { LanguageService } from '@fcom/ui-translate';

/**
 * Transforms a weekday number to a localized string. E.g. on english locale:
 * 1 -> 'Monday'
 * 2 -> 'Tuesday'
 * 3 -> 'Wednesday'
 * ...
 */

@Pipe({
  name: 'finWeekday',
  standalone: false,
})
export class WeekdayPipe implements PipeTransform, OnDestroy {
  private ref = inject(ChangeDetectorRef);
  private languageService = inject(LanguageService);

  private async: AsyncPipe;
  private cachedInput: number;
  private cached$: Observable<string>;
  private weekdayMap: WeekdayMap = new WeekdayMap('MON');

  constructor() {
    this.async = new AsyncPipe(this.ref);
  }

  transform(input: number): string {
    if (this.valueChanged(input)) {
      this.update(input);
    }
    return this.async.transform(this.cached$);
  }

  ngOnDestroy(): void {
    this.async.ngOnDestroy();
  }

  private valueChanged(input: number): boolean {
    return !this.cached$ || input !== this.cachedInput;
  }

  private update(input: number): void {
    this.cached$ = this.languageService.translate<{ weekdays: Record<number, string> }>('date').pipe(
      map((translations) => {
        return translations.weekdays[this.weekdayMap.get(input)];
      })
    );
    this.cachedInput = input;
  }
}
